import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "complete-order-creation"
    }}>{`Complete Order Creation`}</h1>
    <h4 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h4>
    <p>{`Before creating a rental order from WooCommerce order details page, Please make sure you've already completed the following steps.`}</p>
    <ol>
      <li parentName="ol">{`Install and activate `}<a parentName="li" {...{
          "href": "/installation"
        }}>{`WooCommerce & RnB plugins`}</a>{`.`}</li>
      <li parentName="ol">{`Create a `}<a parentName="li" {...{
          "href": "/complete-product-creation"
        }}>{`complete rental product`}</a>{`.`}</li>
    </ol>
    <h4 {...{
      "id": "steps"
    }}>{`Steps`}</h4>
    <ol>
      <li parentName="ol">{`Login to your `}<inlineCode parentName="li">{`WordPress admin dashboard`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`Dashboard->WooCommerce->order page`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Click `}<inlineCode parentName="li">{`Add Order`}</inlineCode>{` button to create a new order page.`}</li>
      <li parentName="ol">{`In order page right side you'll see `}<inlineCode parentName="li">{`Add Manual Booking`}</inlineCode>{` Panel.`}</li>
      <li parentName="ol">{`Now choose product and other attributes like date, resources, locations etc.`}</li>
      <li parentName="ol">{`After choosing everything from panel click `}<inlineCode parentName="li">{`Save`}</inlineCode>{` or `}<inlineCode parentName="li">{`Update`}</inlineCode>{` button to add this product as order item.`}</li>
    </ol>
    <p>{`If you want to add another item in this order just repeat `}<inlineCode parentName="p">{`step 5`}</inlineCode>{` & `}<inlineCode parentName="p">{`step 6`}</inlineCode>{`.`}</p>
    <p>{`Note: You can add customer `}<inlineCode parentName="p">{`billing and shipping details`}</inlineCode>{` from left panel, you can control the order status from this page also.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      